var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlacements = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 14,
  viewBox: "0 0 12 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12 12v1a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-1zm0-4v3H0V8zm0-4v3H9V4zM8 4v3H4V4zM3 4v3H0V4zm8-4a1 1 0 0 1 1 1v2H0V1a1 1 0 0 1 1-1z"
})));
export default SvgPlacements;